import { Link } from "react-router-dom";
import { ReactComponent as CheckmarkIcon } from "../../../assets/icons/checkmark.svg";

const PricingCard = ({ bg, image, title, info, price, points,to ,handler,plan}) => {
    return (
        <div
            className="card px-2 py-4 text-light h-100"
            style={{
                backgroundColor: bg,
                borderRadius: "1rem",
                width : "22rem"
            }}
        >
            <img
                className="position-absolute start-50 translate-middle"
                style={{ width: "10rem" }}
                src={image}
                alt=""
            />
            <h3 className="text-center" style={{ marginTop: "8rem" }}>
                {title}
            </h3>
            <h5 className="text-center">{info}</h5>
            <div className="d-flex justify-content-center mt-3">
                <h5 className="mt-1 fs-5">$</h5>
                <h1 style={{lineHeight : "0.8"}}>{price}</h1>
                <h5 className="align-self-end">inc GST<span className="fs-5 ms-2">Monthly</span></h5>
            </div>
            <div className="card-body mt-2 d-flex justify-content-center">
                <ul className="checkmark list-unstyled">
                    {points.map((point, i) => (
                        <li key={i} className="text-body-1 text-inverse d-flex align-items-center lh-1 my-3">
                            <span style={{flex:"0 0 1rem"}}><CheckmarkIcon className="me-2" /></span>
                            <span>{point}</span>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="d-flex justify-content-center">
                <button
                    style={{ height: "3rem" }}
                    onClick={() => handler(plan)}
                    className="btn rounded-pill btn-outline-light px-5 d-flex align-items-center"
                >
                    Start Plan
                </button>
            </div>
        </div>
    );
};

export default PricingCard;
